var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28704 12.7812C5.72172 12.7812 6.07407 13.1308 6.07407 13.5623C6.07407 17.3534 9.18102 20.4375 13 20.4375C14.1619 20.4375 15.3109 20.1466 16.3227 19.5963C16.7039 19.389 17.1822 19.5277 17.3911 19.9061C17.6 20.2845 17.4603 20.7593 17.0791 20.9666C15.8361 21.6427 14.4256 22 13 22C10.7296 22 8.59503 21.1223 6.98959 19.5287C5.38416 17.9351 4.5 15.8162 4.5 13.5625C4.5 13.131 4.85236 12.7812 5.28704 12.7812ZM10.7879 2.23157C11.0938 1.92497 11.592 1.92251 11.9009 2.22606C12.1841 2.50432 12.2098 2.94315 11.9765 3.25055L11.9065 3.33091L10.117 5.12498H13C15.2704 5.12498 17.405 6.00263 19.0104 7.59627C20.6158 9.1899 21.5 11.3087 21.5 13.5625C21.5 15.0207 21.119 16.4582 20.3982 17.7198C20.2533 17.9733 19.987 18.1157 19.7129 18.1157C19.5813 18.1157 19.4479 18.0829 19.3253 18.0139C18.9472 17.801 18.8146 17.3242 19.029 16.9489C19.6158 15.922 19.9259 14.751 19.9259 13.5625C19.9259 9.84179 16.933 6.80195 13.2114 6.69064L13 6.68748H10.0985L11.8667 8.48557C12.1703 8.79432 12.1644 9.28893 11.8533 9.59033C11.7002 9.73862 11.5018 9.81252 11.3036 9.81252C11.1331 9.81252 10.9627 9.75789 10.8214 9.64892L10.7403 9.57701L8.75358 7.55681C7.89382 6.6826 7.8628 5.28769 8.65696 4.37565L8.76523 4.25951L10.7879 2.23157Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshPrimary);
export default __webpack_public_path__ + "static/media/refresh-primary.400bc3a6f75d36b2ad3a7488c058f18c.svg";
export { ForwardRef as ReactComponent };